export default "__VITE_ASSET__BEDveXrN__"